module.exports = __webpack_public_path__ + "img/offline-marker.587747e0.svg";